module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/feature_3-b9f10b6ef503ea4210b997d5b6e1d0c3.png";